import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=8b92bbee&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=8b92bbee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b92bbee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b92bbee')) {
      api.createRecord('8b92bbee', component.options)
    } else {
      api.reload('8b92bbee', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=8b92bbee&scoped=true&", function () {
      api.rerender('8b92bbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83M8h9S4UjSHY/JS/comp/CookieBox.vue"
export default component.exports